var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97822 10.9672C6.55744 10.9672 4.61646 9.02643 4.61646 6.6049C4.61646 4.1844 6.55744 2.24365 8.97822 2.24365C11.399 2.24365 13.34 4.1844 13.34 6.6049C13.34 9.02643 11.399 10.9672 8.97822 10.9672Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.616 9.14079C19.6681 8.61608 20.8929 6.55014 20.368 4.49733C19.8434 2.44541 17.7773 1.22089 15.7251 1.74561",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1567 21.8724V18.601C17.1567 16.1921 15.2038 14.2393 12.7949 14.2393H5.16182C2.75288 14.2393 0.800049 16.1921 0.800049 18.601V21.8724",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7925 13.1484V13.1484C21.2014 13.1484 23.1542 15.1013 23.1542 17.5102V20.7815",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcon);
export default __webpack_public_path__ + "static/media/community-icon.cf0b96277320716113bbdaa031b2e9cb.svg";
export { ForwardRef as ReactComponent };